export default "/wp-content/themes/react/dist/app/images/main_img.png";